import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { NavLink } from 'react-router-dom';
import LearnNavigation from '../NavigationDropdown/LearnNavigation';
import Search from '../Search';

const MenuBar = ({ 
  location, 
  isAuthenticated = false, 
  menuItems = [] 
}) => {
  const { pathname } = location;

  const { isDischarge, showLearnNav, showMenuItems } = useMemo(() => {
    const isDischargePath = pathname.includes('discharge');
    const isLearnPath = pathname.includes('learn');
    const isLearnActive = isLearnPath || isDischargePath;

    const deepAppPaths = ['dashboard', 'diary', 'questions', 'options'];
    const isOnDeepPath = deepAppPaths.some(path => pathname.includes(path));

    return {
      isDischarge: isDischargePath,
      showLearnNav: isLearnActive,
      showMenuItems: !isLearnActive && !isOnDeepPath
    };
  }, [pathname]);

  return (
    <nav
      className={classNames('header__secondary-nav', {
        'learn-navigation': showLearnNav
      })}
    >
      {/* 2. Generic Menu Items Section */}
      {showMenuItems && (
        <div className="header__secondary-item">
          <div className="header__secondary-item header__secondary-item--link">
            {menuItems.map(({ url, title }) => (
              <NavLink 
                key={url} 
                className="full-width-link" 
                to={url}
              >
                <span className="full-width-link__text">{title}</span>
              </NavLink>
            ))}

            {isAuthenticated && (
              <NavLink className="full-width-link" to="/glossary">
                <span className="full-width-link__text">Glossary</span>
              </NavLink>
            )}
          </div>
        </div>
      )}

      {/* 3. Specialized Education Navigation */}
      {showLearnNav && (
        <LearnNavigation location={location} isDischarge={isDischarge} />
      )}

      {/* 4. Desktop Search (Authenticated Only) */}
      {isAuthenticated && (
        <div className="header__secondary-item header__search-container header__search-container--desktop">
          <Search />
        </div>
      )}
    </nav>
  );
};

MenuBar.propTypes = {
  location: PropTypes.shape({ pathname: PropTypes.string }).isRequired,
  isAuthenticated: PropTypes.bool,
  menuItems: PropTypes.arrayOf(
    PropTypes.shape({
      url: PropTypes.string,
      title: PropTypes.string
    })
  )
};

export default MenuBar;
